<template>
  <div
    v-if="isNewHeader"
    class="tw-py-[15px] tw-px-[26px] tw-bg-bgPage tw-border-0 tw-border-t-[1px] tw-border-solid tw-border-forLine"
  >
    <div class="tw-flex tw-justify-between">
      <div class="">
        <h1
          class="tw-flex tw-items-center tw-gap-[10px] tw-text-[15px] tw-text-forTitle tw-font-[600] tw-m-0"
        >
          Раздел {{ currentNumPage }}
          <div
            class="tw-w-[6px] tw-h-[6px] tw-bg-[#0056AF] tw-rounded-full"
          ></div>
          <span v-if="dataLang[currentNamePage] == 'Легковой'"> Наземный </span>
          <span v-else>
            {{ dataLang[currentNamePage] }}
          </span>
        </h1>
      </div>
      <div
        v-if="currentMenu?.id"
        @click="$modal.show('modalVideoSupport', { id: currentMenu?.id })"
        class="tw-flex tw-items-center tw-gap-[8px] tw-cursor-pointer"
      >
        <img
          :src="require(`@/assets/icons/live-video.svg`)"
          class="tw-w-[13px]"
        />
        <div class="tw-text-[12px] tw-text-forTitle hover:tw-underline">
          Посмотреть видеоинструкцию
        </div>
      </div>
    </div>
    <slot></slot>
  </div>
  <!-- старая разметка -->
  <div v-else class="top-line container-fluid">
    <div class="top-line__layout align-items-center">
      <div class="top-line__inner-title py-10">
        <h1 class="fsc-16 fw-normal">
          ({{ currentNumPage }}) {{ dataLang[currentNamePage] }}
        </h1>
        <div
          class="top-line__round-tooltip top-line-round-tooltip fsc-16"
          data-bs-toggle="tooltip"
          title="Видеоруководство по разделу. Кликните чтобы начать"
        ></div>
      </div>
      <div
        v-if="currentMenu?.id"
        @click="$modal.show('modalVideoSupport', { id: currentMenu?.id })"
        class="top-line__desc-link cursor-pointer"
      >
        Посмотреть видеоинструкцию
      </div>
    </div>
    <slot></slot>
  </div>
  <!-- старая разметка -->
</template>

<script>
import Modals from "@/components/Modals.vue";
import EventBus from "@/event-bus";
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  components: {
    Modals,
  },
  data() {
    return {
      currentMenu: {},
    };
  },
  methods: {},

  created() {},

  watch: {
    $route(to, from) {
      this.currentMenu = this.menuDataByKey[this.$route.name];
      console.log("get route name", this.currentMenu);
    },
  },

  mounted() {
    let interval = setInterval(() => {
      if (this.menuDataByKey[this.$route.name]) {
        this.currentMenu = this.menuDataByKey[this.$route.name];
        if (this.currentNumPage && this.dataLang[this.currentNamePage]) {
          document.title =
            this.currentNumPage + " • " + this.dataLang[this.currentNamePage];
        } else {
          document.title = "Платформа Сириус";
        }
        clearInterval(interval);
      }
    }, 10);
  },

  computed: {
    ...mapState("menuModule", ["menuDataByKey", "loadStatus", "menuData"]),
    ...mapState("translationModule", ["dataLang"]),

    isNewHeader() {
      let routes = [
        "/transport/nodriver",
        "/admin-sms",
        "/finreestr",
        "/transport/archive",
        "/global-settings",
        "/fine-subs-managment",
        "/admin-gps",
        "/book/contacts",
        "/company_notifications",
        "/toll-roads",
        "/academy",
        "/clients/black",
        "/book/passwords",
        "/fines",
        "/owners",
        "/countries",
        "/book/admin-passwords",
        "/products",
        "/admin/referals",
        "/sb-1",
        "/sb-2",
        "/price",
        "/orders/archive",
        "/ads",
        "/super/b2b-orders",
        "/super/requests_for_payment",
        "/super/money-back-requests",
        "/super/moderation-page",
        "/super/gps",
        "/marks-admin",
        "/super/companies",
        "/super/video",
        "/super/countries_regions_cities",
        "/super/translations",
        "/super/academy",
        "/employees",
        "/clients/white",
        "/super/settings"
      ];
      return routes.includes(this.$route.path);
    },

    currentNamePage() {
      if (this.currentMenu) {
        return this.currentMenu.title;
      }
      return null;
    },

    currentNumPage() {
      if (this.currentMenu) return this.currentMenu.position;
      return null;
    },

    computedCurrentTitlePage() {
      if (this.currentNamePage && this.currentNumPage) {
        document.querySelector(
          "title"
        ).textContent = `(${this.currentNumPage}) ${this.currentNamePage}`;
        return this.currentMenu.title;
      }
      document.querySelector("title").textContent = `Платформа Сириус`;
      return "";
    },
  },
};
</script>
